// extracted by mini-css-extract-plugin
module.exports = {"ReportImagesArea":"ReportImagesArea_ReportImagesArea__KGS46","ReportImageList":"ReportImagesArea_ReportImageList__G2bXE"};